/*
 * @Author: yanghailong
 * @Date: 2025-03-26 10:33:05
 * @Last Modified by: yanghailong
 * @Last Modified time: 2025-03-27 13:50:12
 */

import { createVNode, render } from "vue"
import { createElement } from "@/topo/core/utils/index.js"
import LibComponent from "@/topo/editor/lib-ui/index.vue"

const groups = [
  {
    groupName: '基础元件',
    groupType: 'base',
    children: [
      {
        type: 'text',
        text: '文本',
      },
      {
        type: 'rect',
        text: '矩形',
      },
      {
        type: 'circle',
        text: '圆形',
      },
      {
        type: 'foldLine',
        text: '折线',
      },
    ],
  },
  {
    groupName: '电力系统元件',
    groupType: 'power',
    children: [
      {
        type: 'bus',
        text: '母线',
      },
      {
        type: 'eBlock',
        text: '能量块',
      },
      {
        type: 'eLink',
        text: '能量链',
      },
      {
        type: 'ess',
        text: '储能系统',
        libImg: 'essLib',
      },
      // {
      //     type: 'pa',
      //     text: '计量电表',
      // },
      {
        type: 'payload',
        text: '负载',
      },
      {
        type: 'pcc',
        text: '电表',
      },
      // {
      //   type: 'pcs',
      //   text: '逆变器',
      //   libImg: 'pcs-lib',
      // },
      {
        type: 'pv',
        text: '光伏',
        libImg: 'pvLib',
      },
      {
        type: 'transformer',
        text: '变压器',
      },
      {
        type: 'square',
        text: '储能方阵',
      },
      {
        type: 'chargePile',
        text: '充电桩',
      },
      {
        type: 'breaker',
        text: '断路器',
      },
      {
        type: 'ground',
        text: '接地',
      },
    ]
  },
]

export function initLib() {
  const etLib = createElement('div', ['et-lib'])
  const vnode = createVNode(LibComponent, { groups })
  render(vnode, etLib)
  return etLib
}
